<template>
  <modal :name="name" v-model="showModal" height="auto" @closed="handleClose">
    <template #title>
      <h2 class="text-90 font-normal text-xl">{{ header }}</h2>
    </template>

    <template #content>
      <div class="p-8">
        <p class="text-80 leading-normal">{{ content }}</p>
        <slot/>
      </div>
    </template>

    <template #footer>
      <button type="button"
              class="button button_cancel"
              @click.prevent="handleClose">
        {{ trans('common.cancel') }}
      </button>

      <button type="button"
              id="confirm-delete-button"
              class="button button_danger"
              @click.prevent="handleConfirm">
        {{ trans('common.delete') }}
      </button>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Shared/Modal";

export default {
  name: 'ConfirmDeleteModal',
  components: {Modal},

  props: {
    name: String,

    header: {
      type: String,
      required: true,
    },

    content: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    showModal: true
  }),

  mounted() {
    this.$vfm.show(this.name);
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },

    handleConfirm() {
      this.$emit('confirm');
      this.handleClose();
    },
  },
};
</script>
